/**
 * Server-side Google Tag Manager endpoint that receives collected events.
 * When undefined, the sGTM destination is a no-op.
 */
export const SGTM_ENDPOINT_URL: string | undefined = import.meta.env
  .VITE_SGTM_ENDPOINT_URL;

/**
 * GA4 measurement ID sent as the top-level `tid` field of the event payload.
 * When undefined, the sGTM destination is a no-op.
 */
export const SGTM_GA_MEASUREMENT_ID: string | undefined = import.meta.env
  .VITE_SGTM_GA_MEASUREMENT_ID;
